import * as Icons from '@ant-design/icons'
import { CompanyStatus } from '@models/business/CompanyStatus'
import { selectCompanyStatusById } from '@store/business/CompanyStatusReducer'
import { useAppSelector } from '@store/hooks'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Flex, Tag } from 'antd'

type Props = SBModelComponent<CompanyStatus> & {}

export const StatusTag = ({ id, model }: Props) => {
  const item = model ? model : useAppSelector(selectCompanyStatusById(id!))
  const DynamicIcon: any = Icons[item?.icon as keyof typeof Icons]

  if (!item) {
    return <></>
  }

  return (
    <>
      <Flex align="center" gap={8}>
        <Tag
          icon={DynamicIcon ? <DynamicIcon /> : undefined}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '32px',
            lineHeight: 1,
            padding: '4px 12px',
          }}
          color={item.color}
        >
          {item.name}
        </Tag>
      </Flex>
    </>
  )
}

export type StatusTagType = { StatusTag: typeof StatusTag }
